import { i18n } from '@/locales/i18n-setup'
import {
  Rows3,
  CircleDollarSign,
  Receipt,
  Clock,
  MessageSquareMore,
  Wallet,
  LogOut
} from 'lucide-vue'

export default function () {
  return [
    {
      label: i18n.t('mainNavigation.accounts'),
      to: { name: 'AccountsList' },
      icon: Rows3,
      e2eLabel: 'accounts'
    },
    {
      label: i18n.t('mainNavigation.bills'),
      to: { name: 'BillList' },
      icon: CircleDollarSign,
      e2eLabel: 'bills'
    },
    {
      label: i18n.t('mainNavigation.receipts'),
      to: { name: 'PaymentList' },
      icon: Receipt,
      e2eLabel: 'receipts'
    },
    {
      label: i18n.t('mainNavigation.scheduledPayments'),
      to: { name: 'ScheduledTypePayments' },
      icon: Clock,
      e2eLabel: 'scheduled-payments'
    },
    {
      label: i18n.t('mainNavigation.messageSettings'),
      to: { name: 'MessageSettings' },
      icon: MessageSquareMore,
      e2eLabel: 'message-settings'
    },
    {
      label: i18n.t('mainNavigation.paymentMethods'),
      to: { name: 'PaymentMethodList' },
      icon: Wallet,
      e2eLabel: 'payment-methods'
    },
    {
      label: i18n.t('labels.logout'),
      to: { name: 'Logout' },
      icon: LogOut,
      e2eLabel: 'logout',
      divideBefore: true
    }
  ]
}
